import { useState } from 'react';
import CheckboxTree, { OnCheckNode } from 'react-checkbox-tree';
import { useShallow } from 'zustand/shallow';

import { POIFilterType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiFilterType';
import { getPoiFilterData } from 'app/modules/wallforming/components/scenes/objects/pois/utils/poiFilterUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import 'app/modules/wallforming/custom-styles/customCheckboxTreeStyle.css';

export const POIFilter = () => {
    const poiFilterNodes = getPoiFilterData();
    const poiFilterValues = poiFilterNodes.map((node) => node.value);

    const { hiddenPOIFilterTypes, addHiddenPOIFilterTypes, removeHiddenPOIFilterTypes } = usePlacementStore(
        useShallow((state) => ({
            hiddenPOIFilterTypes: state.hiddenPOIFilterTypes,
            addHiddenPOIFilterTypes: state.addHiddenPOIFilterTypes,
            removeHiddenPOIFilterTypes: state.removeHiddenPOIFilterTypes
        }))
    );

    const [checked, setChecked] = useState<string[]>(
        // Initialize checked state with all POI filter values that are not hidden
        poiFilterValues.filter((value) => !hiddenPOIFilterTypes.includes(value as POIFilterType))
    );

    const handleFilterPOIs = (checkedItems: string[], node: OnCheckNode) => {
        setChecked(checkedItems);
        node.checked = !node.checked;

        Object.values(POIFilterType).forEach((type) => {
            if (!checkedItems.includes(type) && !hiddenPOIFilterTypes.includes(type)) {
                addHiddenPOIFilterTypes(type);
            } else if (checkedItems.includes(type) && hiddenPOIFilterTypes.includes(type)) {
                removeHiddenPOIFilterTypes(type);
            }
        });
    };

    return (
        <div className="flex flex-col h-full w-full text-sm mb-1">
            <CheckboxTree
                checked={checked}
                nodes={poiFilterNodes}
                onCheck={(checked, node) => handleFilterPOIs(checked, node)}
            />
        </div>
    );
};
